import React, { useEffect, useRef } from "react";
import MobImg from "../../Assets/Images/Doctor_img.png";
import Section2Img from "../../Assets/Images/section-2.jpg";
import Section3Img from "../../Assets/Images/section-3.jpg";
import Section4Img from "../../Assets/Images/section-4.jpg";
import Section5Img from "../../Assets/Images/section-5.jpg";
import Section6Img from "../../Assets/Images/section-6.jpg";
import Section7Img from "../../Assets/Images/section-7.png";
import Section8Img from "../../Assets/Images/section-8.jpg";
import { Check } from "lucide-react";
import RedirectionLinks from "../../Components/AfCare/RedirectionLinks";
import {
  liveChat,
  secondMedicalOpinion,
  telehealthFeatures,
} from "../../Assets/Constant/Constants";
import "./AfCare.css";

function mapValue(value, inMin, inMax, outMin, outMax) {
  return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
}

const AfCareSections = () => {
  const mainref = useRef(null);
  const imgref = useRef(null);

  const jumpToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });

      // Optional: Simulate intersection for animations if needed
      setTimeout(() => {
        const observerEvent = new Event("scroll");
        document.dispatchEvent(observerEvent);
      }, 500); // Delay to ensure scroll completes
    }
  };

  useEffect(() => {
    const mainElement = mainref.current;
    const imgElement = imgref.current;
    const sections = document.querySelectorAll("section");
    const options = {
      threshold: 0.5, // 50% of the section must be visible
    };

    let prevIndex = 0;
    const images = document.querySelectorAll(".overlay-images img"); // Assuming each image has the class "image"
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, sectionIndex) => {
        let currentId = entry.target.id.split("-")[1];
        if (entry.isIntersecting) {
          // &&
          //   entry.target.id !== "section-2"
          // (screenSize > 1024 && entry.target.id === "section-2")
          if (
            entry.target.id !== "section-1" &&
            !(window.innerWidth > 1024 && entry.target.id === "section-2")
          ) {
            document.getElementById(`${entry.target.id}-img`).style.visibility =
              "visible";
            document.getElementById(
              `${entry.target.id}-img`
            ).classList = `animate__animated animate__fadeInUp`;
          }

          if (entry.target.id == "section-1") {
            document.getElementById("footer-links").style.display = "none";
          } else {
            document.getElementById("footer-links").style.display = "flex";
          }

          if (prevIndex > currentId) {
            images.forEach((img, index) => {
              if (currentId < img.id.split("-")[1]) {
                img.style.visibility = "hidden";
              }
            });
          }
        } else {
          if (entry.target.id !== "section-1") {
            document.getElementById(`${entry.target.id}-img`).classList = "";
          }
        }
        prevIndex = currentId;
      });
    }, options);

    sections.forEach((section) => observer.observe(section));

    const handleScroll = () => {
      if (imgElement) {
        imgElement.style.bottom = "50%";
        imgElement.style.transform =
          "translateX(-50%) translateY(calc(50% + 10%))";

        if (mainElement.scrollTop < mainElement.offsetHeight) {
          // imgElement.style.bottom = `${[mainElement.scrollTop * 0.55] - 85}px`;
          // imgElement.style.bottom = "50%";

          // Calculate dynamic width for the image based on scroll position
          imgElement.style.width = `${mapValue(
            mainElement.scrollTop,
            0,
            mainElement.offsetHeight
          )}px`;
        }

        if (window.innerWidth < 1024) {
          // imgElement.style.bottom = unset;
          // imgElement.style.bottom = "50%";
          // imgElement.style["--tw-translate-y"] = "calc(50% + 40px)";
          imgElement.style.transform = "translateX(-50%) translateY(110%)";
        } else {
          if (mainElement.scrollTop <= 0) {
            // imgElement.style.bottom = `2vh`;
            // imgElement.style.bottom = "50%";
            // imgElement.style["--tw-translate-y"] = "110%";
            imgElement.style.transform = "translateX(-50%) translateY(110%)";
            imgElement.classList.add("scrolled-not-first-element");
            document.getElementById("section-1-img").style.width = "420px";
          } else {
            document.getElementById("section-1-img").style.width = "280px";
          }
        }
      }
    };

    if (mainElement) {
      document.body.scrollIntoView(mainElement);
      document.getElementsByTagName("html")[0].style.overflow = "hidden";
      handleScroll();
      mainElement.addEventListener("scroll", handleScroll);
      mainElement.addEventListener("resize", handleScroll);
    }

    //cleanup
    return () => {
      if (mainElement) {
        document.getElementsByTagName("html")[0].style.overflow = "auto";
        mainElement.removeEventListener("scroll", handleScroll);
        mainElement.removeEventListener("resize", handleScroll);
      }
    };
  }, []);

  return (
    <div
      style={{
        background:
          "linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(245.82, 139.23, 147.39, 0.09) 37%, rgba(83, 188, 200, 0.09) 61%, rgba(83, 188, 200, 0) 99%)",
      }}
    >
      <main
        ref={mainref}
        className="overflow-y-scroll h-screen Scroll_Behaviour"
      >
        {/* translate-y-[110%] -translate-x-1/2 */}
        <div
          ref={imgref}
          className="w-[100%] rounded z-20 pointer-events-none  -translate-x-1/2 fixed bottom-[50%]  left-1/2"
          style={{ height: "calc(-200px + 100vh)" }}
        >
          <div className="overlay-images">
            <img
              src={MobImg}
              id="section-1-img"
              alt="Mobile App Interface"
              style={{ visibility: "visible", width: "320px" }}
            />
            <img
              src={Section2Img}
              id="section-2-img"
              alt="Mobile App Interface"
            />
            <img
              src={Section3Img}
              id="section-3-img"
              alt="Mobile App Interface"
            />
            <img
              src={Section4Img}
              id="section-4-img"
              alt="Mobile App Interface"
            />
            <img
              src={Section5Img}
              id="section-5-img"
              alt="Mobile App Interface"
            />
            <img
              src={Section6Img}
              id="section-6-img"
              alt="Mobile App Interface"
            />
            <img
              src={Section7Img}
              id="section-7-img"
              alt="Mobile App Interface"
              className="rounded-xl"
              style={{ "border-radius": "30px" }}
            />
            <img
              src={Section8Img}
              id="section-8-img"
              alt="Mobile App Interface"
            />
          </div>
        </div>
        {/* Hero Section */}
        <section className="max-w-6xl mx-auto px-4 py-8 h-full" id="section-1">
          <div className="text-center mb-8 md:mb-12 md:mt-8 lg:mt-18">
            <p className="font-regular lg:font-semibold mb-1 lg:mb-4 mt-[18vh] text-[13px] lg:text-lg">
              Discover our AF Care Program
            </p>
            <h1 className="leading-tight lg:leading-none text-[22px] md:text-[48px] lg:text-[60px] font-bold mb-6 md:mb-8 px-4">
            Extensive benefits, services, and<br />
              tools to enhance your experience
            </h1>

            <RedirectionLinks
              onJumpToSection={jumpToSection}
              className={"mt-[20px] lg:mt-[40px]"}
            />
          </div>
        </section>

        {/* Telehealth Section */}
        <section
          className="flex flex-col lg:justify-center justify-start items-center h-screen py-14 md:py-24"
          id="section-2"
        >
          <div className="max-w-6xl mx-auto grid lg:grid-cols-3 gap-8 items-center">
            {/* Left Content */}
            <div className="space-y-4 mt-[48px] px-8 lg:px-4">
              <div>
                <h2 className="text-[12px] lg:text-[14px] text-black mb-1 text-left">
                  Telehealth
                </h2>
                <h3 className="leading-tight text-[18px] lg:text-[22px] font-semibold mb-4 lg:mb-8 text-left">
                  Online Medical Consultations 24/7 <br /> service, in 20
                  languages from the comfort of your home.
                </h3>
              </div>

              <div className="space-y-2">
                {telehealthFeatures.map((feature, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                      <Check className="w-3 h-3 text-white" />
                    </div>
                    <span className="text-sm text-black text-left">
                      {feature}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Mental Health Coaching Section */}

        <section
          className="flex flex-col lg:justify-center justify-start items-center h-screen py-14 md:py-24"
          id="section-3"
        >
          <div className="lg:max-w-6xl max-w-2xl mx-auto grid lg:grid-cols-3 gap-8 items-center">
            {/* Spacer for Left Side */}
            <div className="hidden lg:block"></div>

            {/* Spacer for Middle */}
            <div className="hidden lg:block"></div>

            {/* Right Content */}
            <div className="space-y-4 mt-[48px] px-8 lg:px-4">
              <div>
                <h2 className="text-[12px] lg:text-[14px] text-black mb-1">
                  Mental Health Coaching Program
                </h2>
                <h3 className="leading-tight text-[18px] lg:text-[22px] font-semibold mb-4 lg:mb-8">
                Your path to help you feel better, manage emotions and improve well-being with mental health professionals.
                </h3>
              </div>

              <div className="space-y-2">
                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black">Unlimited sessions</span>
                </div>

                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black">
                    Access to mental health coaches
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black">
                  Designed to help manage  emotions, improve relationship skills, challenge  negative thinking, and reduce  stress
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Alfi Section */}
        <section
          className="flex flex-col lg:justify-center justify-start items-center h-screen py-16 md:py-24"
          id="section-4"
        >
          <div className="max-w-6xl mx-auto grid lg:grid-cols-3 gap-8 items-center">
            {/* Left Content */}
            <div className="space-y-4 lg:space-y-8 mt-[50px] px-8 lg:px-4">
              <div className="flex flex-col-reverse lg:flex-col">
                <h2 className="text-[40px] lg:text-7xl leading-none font-semibold mb-0 lg:mb-2 text-left">
                  Hello!{" "}
                  <span className="inline-block lg:hidden"> I'm Alfi</span>
                </h2>
                <h2 className="hidden lg:block text-[40px] lg:text-7xl leading-none font-semibold mb-0 lg:mb-4 text-left">
                  I'm Alfi
                </h2>
                <h3 className="text-[12px] lg:text-base text-black mb-3 text-left">
                  Meet Alfi, your 24/7 smart service assistant
                </h3>
              </div>

              <div className="space-y-1">
                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black text-left">
                    Service available via portals
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black text-left">
                    Support in multiple languages
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black text-left">
                    Access for quick responses on products, benefits, and
                    processes
                  </span>
                </div>
              </div>
            </div>

            {/* Right Spacer */}
            <div className="hidden lg:block"></div>
            <div className="hidden lg:block"></div>
          </div>
        </section>

        <section
          className="flex flex-col lg:justify-center justify-start items-center h-screen py-14 md:py-24"
          id="section-5"
        >
          <div className="max-w-6xl mx-auto grid lg:grid-cols-3 gap-8 items-center">
            {/* Left Content */}
            <div className="space-y-4 mt-[50px] px-4">
              <div>
                <h2 className="text-[12px] lg:text-[14px] text-black mb-1 text-left">
                  Second Medical Opinion
                </h2>
                <h3 className="leading-tight text-[18px] lg:text-[24px] font-semibold mb-4 lg:mb-8 text-left">
                Confirm your diagnosis and treatment with medical specialists.
                </h3>
              </div>

              <div className="space-y-2">
                {secondMedicalOpinion.map((feature, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                      <Check className="w-3 h-3 text-white" />
                    </div>
                    <span className="text-sm text-black text-left">
                      {feature}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section
          className="flex flex-col lg:justify-center justify-start items-center h-screen py-14 md:py-24"
          id="section-6"
        >
          <div className="max-w-6xl mx-auto grid lg:grid-cols-3 gap-8 items-center">
            {/* Spacer for Left Side */}
            <div className="hidden lg:block"></div>

            {/* Spacer for Middle */}
            <div className="hidden lg:block"></div>

            {/* Right Content */}
            <div className="space-y-4 mt-[48px] px-8 lg:px-4">
              <div>
                <h3 className="leading-tight text-[18px] lg:text-[24px] text-black mb-4 lg:mb-8">
                <b className="font-semibold">Care Service Program & </b>{" "}Medication Management
                </h3>
          
              </div>

              <div className="space-y-2">
                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black">
                    Assistance with delivery and management of specialized
                    medications
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black">
                    Coordination and delivery of specialty medications in U.S. and
                    Latin America
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black">
                    Access to discounts on U.S. network pharmacies
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black">
                    Improve patient experience with dedicated assistance
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black">
                    Coordination of medical services and personalized team
                    support
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="flex flex-col lg:justify-center justify-start items-center h-screen py-14 md:py-24"
          id="section-7"
        >
          <div className="max-w-6xl mx-auto grid lg:grid-cols-3 gap-8 items-center">
            {/* Left Content */}
            <div className="space-y-4 mt-[48px] px-8 lg:px-4">
              <div>
                <h3 className="text-[40px] lg:text-7xl leading-none font-semibold mb-4 lg:mb-8 text-left">
                  Live Chat
                </h3>
              </div>

              <div className="space-y-2">
                {liveChat.map((feature, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                      <Check className="w-3 h-3 text-white" />
                    </div>
                    <span className="text-sm text-black text-left">
                      {feature}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section
          className="flex flex-col lg:justify-center justify-start items-center h-screen py-14 md:py-24"
          id="section-8"
        >
          <div className="max-w-6xl mx-auto grid lg:grid-cols-3 gap-8 items-center">
            {/* Spacer for Left Side */}
            <div className="hidden lg:block"></div>

            {/* Spacer for Middle */}
            <div className="hidden lg:block"></div>

            {/* Right Content */}
            <div className="space-y-4 mt-[48px] px-8 lg:px-4">
              <div>
                <h3 className="leading-tight text-[18px] lg:text-[24px] text-black mb-4 lg:mb-8">  
                Depending on the plan you can 
                  <b className="font-semibold"> earn up to $500 towards</b>{" "}
                  your annual policy renewal premium.
                </h3>
              </div>

              <div className="space-y-2">
                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black">
                    Get your annual checkups to earn rewards
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black">
                    Enroll automatically by registering at the member portal
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black">
                  Your credits are applied to your annual policy renewal premium
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-4 h-4 rounded-full bg-[#8BB6B8] flex items-center justify-center">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-sm text-black">
                  The insurer does not issue any claims payments during two consecutive years, except for Yearly Routine or Preventive Care Exams
                  </span>
                </div>
              </div>
            </div>
          </div>
          
          <div id="footer-links" className="flex justify-center">
          
            <RedirectionLinks
              onJumpToSection={jumpToSection}
              className="fixed bottom-[0.75rem] hidden lg:flex"
            />
            <p className="text-xs text-gray-500 Myriad-font fixed bottom-[0.75rem] left-[8rem] hidden lg:flex" >ESB-9698</p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AfCareSections;
